function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Box, makeStyles } from '@applyboard/ui-components';
import { Keys, placeholders } from "../Constants";
import { getApplication } from "../../../../store/Selectors";
import EducationStatus from "../EducationStatusComponent";
import SearchComponentV2 from "../SearchComponentV2";
import { GetDegreeOptionsByEducationLevel } from "../../Utilities/MapTools";
import SelectComponent from "../SelectComponent";
import { setField } from "../../../../store/Actions/Actions";
import { scrollIfNeeded } from "../../Utilities/Helper";
var useStyles = makeStyles({
  menu: {
    marginBottom: '32px'
  },
  status: {
    marginBottom: '24px'
  }
});
var Question5 = function Question5(props) {
  var countryOfResidence = props.countryOfResidence,
    educationLevel = props.educationLevel,
    educationStatusErrorMessage = props.educationStatusErrorMessage,
    educationCountry = props.educationCountry,
    educationCountryErrorMessage = props.educationCountryErrorMessage,
    educationLevelErrorMessage = props.educationLevelErrorMessage,
    degreeErrorMessage = props.degreeErrorMessage,
    clearError = props.clearError,
    countriesData = props.countriesData,
    educationData = props.educationData,
    isMobile = props.isMobile,
    degree = props.degree;
  var classes = useStyles();
  var _useState = useState(GetDegreeOptionsByEducationLevel(educationData === null || educationData === void 0 ? void 0 : educationData.levels, educationLevel)),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  useEffect(function () {
    setOptions(GetDegreeOptionsByEducationLevel(educationData === null || educationData === void 0 ? void 0 : educationData.levels, educationLevel));
  }, [educationData, educationLevel]);
  useEffect(function () {
    if (!educationLevel || options && !options.find(function (o) {
      return o.id === degree;
    })) {
      props.setField({
        key: Keys.Application.degree,
        value: ''
      });
    } else {
      var type = options && options.find(function (i) {
        return i.id === degree;
      }).value;
      props.setField({
        key: Keys.Application.educationType,
        value: type !== null && type !== void 0 ? type : null
      });
    }
  }, [educationData, educationLevel, options, degree]);
  var degreeRef = useCallback(function (node) {
    return scrollIfNeeded(node);
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    className: classes.status
  }, /*#__PURE__*/React.createElement(EducationStatus, {
    keyName: Keys.Application.educationStatus,
    isMobile: isMobile,
    clearError: clearError,
    errorMessage: educationStatusErrorMessage
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.menu
  }, /*#__PURE__*/React.createElement(SearchComponentV2, {
    keyName: Keys.Application.educationCountry,
    errorMessage: educationCountryErrorMessage,
    clearError: clearError,
    items: countriesData,
    pinnedItems: [countryOfResidence === null || countryOfResidence === void 0 ? void 0 : countryOfResidence.name],
    placeholder: placeholders.educationCountry,
    isMobile: isMobile,
    isOutlined: true,
    field: educationCountry,
    setField: props.setField
  })), /*#__PURE__*/React.createElement(Box, {
    className: classes.menu
  }, /*#__PURE__*/React.createElement(SelectComponent, {
    keyName: Keys.Application.educationLevel,
    errorMessage: educationLevelErrorMessage,
    clearError: clearError,
    items: educationData === null || educationData === void 0 ? void 0 : educationData.families,
    placeholder: placeholders.educationLevel
  })), educationLevel && options && /*#__PURE__*/React.createElement(Box, {
    className: classes.menu,
    ref: degreeRef
  }, /*#__PURE__*/React.createElement(SelectComponent, {
    keyName: Keys.Application.degree,
    errorMessage: degreeErrorMessage,
    clearError: clearError,
    items: options,
    placeholder: placeholders.degree
  })));
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ref;
  var application = getApplication(state);
  return _ref = {}, _defineProperty(_ref, Keys.Application.countryOfResidence, application.countryOfResidence), _defineProperty(_ref, "educationCountry", application[Keys.Application.educationCountry]), _defineProperty(_ref, Keys.Application.educationLevel, application.educationLevel), _defineProperty(_ref, "educationStatus", application[Keys.Application.educationStatus]), _defineProperty(_ref, "educationType", application[Keys.Application.educationType]), _defineProperty(_ref, Keys.Application.degree, application.degree), _defineProperty(_ref, "educationCountryErrorMessage", ownProps.educationCountryErrorMessage), _defineProperty(_ref, "educationLevelErrorMessage", ownProps.educationLevelErrorMessage), _defineProperty(_ref, "gmatTest", application.gmatTest), _defineProperty(_ref, "greTest", application.greTest), _defineProperty(_ref, "standardizedTests", application.standardizedTests), _defineProperty(_ref, "educationStatusErrorMessage", ownProps.educationStatusErrorMessage), _defineProperty(_ref, "degreeErrorMessage", ownProps.degreeErrorMessage), _defineProperty(_ref, "clearError", ownProps.clearError), _defineProperty(_ref, "countriesData", ownProps.countriesData), _defineProperty(_ref, "educationData", ownProps.educationData), _defineProperty(_ref, "isMobile", ownProps.isMobile), _ref;
};
var connector = connect(mapStateToProps, {
  setField: setField
});
export default connector(Question5);